import React, { useEffect, useState } from "react";

import { DataGrid } from "@mui/x-data-grid";
import { apiGet } from "../../api";

const GridEmpresas = (params) => { 

    const [rows, setRows] = useState([]);

    useEffect(() => {
        apiGet("/empresas").then((response) => {
          if (response && response.data) {
            setRows(response.data);
          }
        });
      }, []);

    const columns = [
        { field: "nome", headerName: "Nome", width: 500},
      ];

    return (<div style={{ height: 550, width: "100%" }}>
    <DataGrid
      rows={rows}
      columns={columns}
      pageSize={10}
      rowsPerPageOptions={[10]}
      checkboxSelection
      disableMultipleSelection={true}
      onSelectionModelChange={params.handleCellSelected}
    />
  </div>);
}

export default GridEmpresas;